import { NavLink } from "react-router-dom";
import { useParentDrawer } from "../context/ParentDrawerContext";
import logo from "../assets/images/logo.png";
function DrawerItem({ to, icon, label, badge, onClick }) {
  return (
    <NavLink to={to} className={({ isActive }) => `ni-drawer${isActive ? " active" : ""}`} onClick={onClick}>
      <i className={`ti ${icon}`} aria-hidden="true" />
      <span className="drawer-label">{label}</span>
      {badge > 0 && <span className="drawer-badge">{badge > 99 ? "99+" : badge}</span>}
    </NavLink>
  );
}

export default function ParentDrawer({ badges, getParentPath, onJustificationsClick, onLogoutClick }) {
  const { drawerOpen, closeDrawer } = useParentDrawer();

  return (
    <>
      <div onClick={closeDrawer} style={{
        position: "fixed", inset: 0, zIndex: 1040,
        background: "rgba(0,0,0,0.45)",
        opacity: drawerOpen ? 1 : 0,
        pointerEvents: drawerOpen ? "auto" : "none",
        transition: "opacity 0.3s",
      }} />

      <div style={{
        position: "fixed", top: 0, left: 0, bottom: 0, zIndex: 1050,
        width: 290, maxWidth: "85vw", background: "#fff",
        transform: drawerOpen ? "translateX(0)" : "translateX(-100%)",
        transition: "transform 0.32s cubic-bezier(.4,0,.2,1)",
        display: "flex", flexDirection: "column",
        boxShadow: "4px 0 30px rgba(0,0,0,0.2)",
      }}>
        <div className="drawer-header">
          <div className="drawer-logo-wrapper">
            <img src={logo} alt="Logo" className="drawer-logo" />
          </div>
          <div className="drawer-brand">
            <span className="drawer-title">Suivi Scolaire</span>
            <span className="drawer-subtitle">Espace Parent</span>
          </div>
        </div>

        <div className="drawer-nav">
          <DrawerItem to={getParentPath("accueil")} icon="ti-home" label="Accueil" onClick={closeDrawer} />
          <DrawerItem to={getParentPath("bulletins")} icon="ti-book" label="Bulletins scolaires" onClick={closeDrawer} />
  <DrawerItem to={getParentPath("situation-frais")} icon="ti-wallet" label="Situation financière" onClick={closeDrawer} />

          <div className="drawer-item-clickable" onClick={onJustificationsClick} style={{ cursor: "pointer" }}>
            <div className="ni-drawer">
              <i className="ti ti-clipboard-list" aria-hidden="true" />
              <span className="drawer-label">Justifications</span>
            </div>
          </div>

          <div className="drawer-divider" />

          <DrawerItem to={getParentPath("messages")} icon="ti-messages" label="Messages" badge={badges.messages} onClick={closeDrawer} />
          <DrawerItem to={getParentPath("notifications")} icon="ti-bell" label="Notifications" badge={badges.notifications} onClick={closeDrawer} />

          <div className="drawer-divider" />

          <DrawerItem to={getParentPath("abonnements")} icon="ti-credit-card" label="Mes abonnements" onClick={closeDrawer} />
          <DrawerItem to={getParentPath("offres")} icon="ti-shopping-bag" label="Souscrire une offre" onClick={closeDrawer} />

          <div className="drawer-divider" />

          <DrawerItem to={getParentPath("aide")} icon="ti-info-circle" label="À propos" onClick={closeDrawer} />
          <DrawerItem to={getParentPath("contact")} icon="ti-phone" label="Nous contacter" onClick={closeDrawer} />

          <div className="drawer-logout-wrapper">
            <button onClick={onLogoutClick} className="drawer-logout-btn">
              <i className="ti ti-logout" aria-hidden="true" />
              <span>Déconnexion</span>
            </button>
          </div>

        </div>
      </div>
    </>
  );
}